// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__Z35QQ","loading_spinne":"styles_loading_spinne__lmjDU","spin":"styles_spin__ZUZP4"};